import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { signinSilentCallback } from '../../../../redux/actions/auth'

const SilentRenewCallback = () => {
  const dispatch = useDispatch()

  useEffect(() => {
    const init = async () => {
      await dispatch(signinSilentCallback())      
    }
    init()
  }, [])

  return (
    <div className="signin-callback-container" />
  )
}

export default SilentRenewCallback